module.exports = __webpack_public_path__ + "img/sharpen-after.88e685bd.webp";